import { Pipe, PipeTransform } from '@angular/core';
import { AngleDirectionEnum, GroupedInstructionItem } from '@cue/data';
import { FindPathResponseV2 } from '@cue/navigation-services';

@Pipe({
  name: 'pathInstruction',
  standalone: true,
})
export class PathInstructionPipe implements PipeTransform {
  transform(value: FindPathResponseV2): GroupedInstructionItem[] {
    const groupedListResult: GroupedInstructionItem[] = [];

    if (value.path.length > 0 && value.pathInstructions.length > 0) {
      for (let i = 0; i < value.pathInstructions.length; i++) {
        const groupNavItem: GroupedInstructionItem = {
          ...value.pathInstructions[i],
        };
        groupNavItem.instructions = [];

        for (let j = 0; j < value.pathInstructions[i].instructions.length; j++) {
          groupNavItem.instructions.push({
            ...value.pathInstructions[i].instructions[j],
            angleDirection:
              j < value.pathInstructions[i].instructions.length - 1
                ? value.pathInstructions[i].instructions[j + 1].angleDirection
                : AngleDirectionEnum.Straight,
            areaId: value.path.find(
              (x) =>
                x.position ===
                value.pathInstructions[i].instructions[j].points[
                  value.pathInstructions[i].instructions[j].points.length - 1
                ]
            ).areaId,
            categoryIcon: value.path.find(
              (x) =>
                x.position ===
                value.pathInstructions[i].instructions[j].points[
                  value.pathInstructions[i].instructions[j].points.length - 1
                ]
            ).categoryIcon,
            isToNextArea:
              j < value.pathInstructions[i].instructions.length - 1
                ? value.path.find((x) => x.position === value.pathInstructions[i].instructions[j].points[0]).areaId !=
                  value.path.find((x) => x.position === value.pathInstructions[i].instructions[j + 1].points[0]).areaId
                : true,
            nextAreaId:
              i < value.pathInstructions.length - 1
                ? value.path.find((x) => x.position === value.pathInstructions[i + 1].instructions[0].points[0]).areaId
                : null,
          });
        }

        groupedListResult.push(groupNavItem);
      }
    }
    console.log(groupedListResult);
    return groupedListResult;
  }
}
